export type AddCompanyState = 'add' | 'upgrade' | 'hidden'

/**
 * Decides how the "Add New Company" row in CompanySwitcher should render.
 * The company-add cap is org-scoped: `companiesLimit === null` means unlimited
 * (e.g. ULTRA). Only owners can add companies. When an owner is at/over the
 * cap we show an upgrade prompt instead of hiding the affordance.
 */
export const resolveAddCompanyState = ({
    isOwner,
    companiesLimit,
    appCount,
}: {
    isOwner: boolean
    companiesLimit: number | null
    appCount: number
}): AddCompanyState => {
    if (!isOwner) return 'hidden'
    if (companiesLimit === null) return 'add'
    return appCount < companiesLimit ? 'add' : 'upgrade'
}
